import NotActiveLicense from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveLicense.svg?react';
import NotActiveinitialInfo from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveinitialInfo.svg?react';
import NotActiveContact from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/notActiveContact.svg?react';
import ActiveContact from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeContact.svg?react';
import ActiveinitialInfo from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeinitialInfo.svg?react';
import ActiveLicense from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/activeLicense.svg?react';
import { StepType } from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper.type';
export const stepDriverData: StepType[] = [
  {
    label: 'اطلاعات پایه',
    icon: <NotActiveinitialInfo />,
    activeIcon: <ActiveinitialInfo />,
    path: 'driver-info',
  },
  {
    label: 'اطلاعات گواهینامه',
    icon: <NotActiveLicense />,
    activeIcon: <ActiveLicense />,
    path: 'certificate-information',
  },
  {
    label: 'اطلاعات تماس',
    icon: <NotActiveContact />,
    activeIcon: <ActiveContact />,
    path: 'contact-info',
  },
];

export const culpritStepDriverData: StepType[] = [
  {
    label: 'اطلاعات پایه',
    icon: <NotActiveinitialInfo />,
    activeIcon: <ActiveinitialInfo />,
    path: 'driver-information',
  },
  {
    label: 'اطلاعات گواهینامه',
    icon: <NotActiveLicense />,
    activeIcon: <ActiveLicense />,
    path: 'certificate',
  },
  {
    label: 'اطلاعات تماس',
    icon: <NotActiveContact />,
    activeIcon: <ActiveContact />,
    path: 'driver-contract',
  },
];

export const culpritSterOwnerData: StepType[] = [
  {
    label: 'اطلاعات پایه',
    icon: <NotActiveinitialInfo />,
    activeIcon: <ActiveinitialInfo />,
    path: 'owner',
  },
  {
    label: 'اطلاعات تماس',
    icon: <NotActiveContact />,
    activeIcon: <ActiveContact />,
    path: 'owner-contract',
  },
];
